// Background gradient loader - applies gradient after page loads
document.addEventListener('DOMContentLoaded', function() {
  // Add a small delay to ensure all content is loaded
  setTimeout(function() {
    document.body.classList.add('loaded');
  }, 100); // 100ms delay to ensure smooth transition
});

// Also trigger on window load as a fallback
window.addEventListener('load', function() {
  document.body.classList.add('loaded');
});
